import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect } from 'xen/components';
import { useUserContext } from 'xen/providers';
const RootLoggedIn = () => {
    const { userType } = useUserContext();
    if (userType === 'prospect')
        return _jsx(Redirect, { to: "/prospect-home" });
    if (userType === 'client')
        return _jsx(Redirect, { to: "/client-home" });
    return _jsx(Redirect, { to: "/lender-home" });
};
export default RootLoggedIn;
